import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    props: {
        frames: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        currentFrame: {
            type: Number
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var changeImg = function(item) {
            emit("update:currentFrame", item.id);
        };
        return {
            changeImg: changeImg
        };
    }
});
